module.exports = __webpack_public_path__ + "img/dt.70a219db.png";